<div class="one-column-page">
  <div class="one-column-content">
    <router-outlet></router-outlet>
  </div>
</div>
